import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import classNames from 'classnames';
import React, { Component } from 'react';
import { inputVarientType } from '../constants';
import LabelAndHint from '../LabelAndHint/LabelAndHint';
var css = {
  "input": "rui-6OoLS",
  "inputDecorator": "rui-XGzjB",
  "icon-ltr": "rui-IxKZ1",
  "inputWrapper": "rui-yLxOC",
  "input-ltr": "rui-98FzR",
  "prefix": "rui-FL2Uo",
  "prefix-ltr": "rui-HaVL3",
  "primaryPrefix": "rui-VCnsY",
  "secondaryPrefix": "rui-gf1ZC",
  "secondaryCaret": "rui-1M6eC",
  "removeSpinners": "rui-cXknh"
};
var NewTextField = /*#__PURE__*/function (_Component) {
  function NewTextField(props) {
    var _this;
    _classCallCheck(this, NewTextField);
    _this = _callSuper(this, NewTextField, [props]);
    _this.componentDidUpdate = function () {
      var cursorPosition = _this.state.cursorPosition;
      var _this$props = _this.props,
        retainCursorPosition = _this$props.retainCursorPosition,
        focusInput = _this$props.focusInput;
      var inputRef = _this.inputRef.current;
      if (retainCursorPosition && inputRef && inputRef.type === 'text' && document.activeElement === inputRef) {
        inputRef.setSelectionRange(cursorPosition, cursorPosition);
      }
      if (focusInput) {
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
      }
    };
    _this.inputChange = function (event) {
      var _a, _b, _c, _d;
      if (_this.props.type === 'number') {
        if (event.target.validity.valid) {
          (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event.target.value, _this.props.name);
        }
      } else {
        (_d = (_c = _this.props).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, event.target.value, _this.props.name);
      }
    };
    _this.onValueChange = function (event) {
      _this.setState({
        cursorPosition: event.target.selectionStart
      });
      _this.inputChange(event);
    };
    _this.inputKeyUp = function (event) {
      if (!event.target.validity.valid) {
        _this.inputRef.current.value = _this.props.value;
      }
    };
    _this.renderInput = function (classname, icon, onFocus, onBlur) {
      var _this$props2 = _this.props,
        prefix = _this$props2.prefix,
        direction = _this$props2.direction,
        prefixClassName = _this$props2.prefixClassName,
        category = _this$props2.category;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(css.inputWrapper, css["input-".concat(direction)])
      }, prefix && /*#__PURE__*/React.createElement("div", {
        className: classNames(prefixClassName, css.prefix, css["".concat(category, "Prefix")], css["prefix-".concat(direction)])
      }, prefix), /*#__PURE__*/React.createElement("div", {
        className: css.input
      }, /*#__PURE__*/React.createElement("input", Object.assign({
        id: _this.props.id,
        name: _this.props.name,
        type: _this.props.type,
        value: _this.props.value,
        autoComplete: _this.props.autoComplete || "off",
        placeholder: _this.props.placeholder,
        onKeyUp: _this.inputKeyUp,
        onChange: _this.onValueChange,
        disabled: _this.props.disabled,
        className: classNames(classname, css.removeSpinners, _defineProperty({}, css["".concat(category, "Caret")], category)),
        autoFocus: _this.props.autoFocus,
        maxLength: _this.props.maxLength,
        ref: _this.inputRef,
        onBlur: onBlur,
        onFocus: onFocus,
        key: "new-text-field"
      }, _this.props.extras)), /*#__PURE__*/React.createElement("div", {
        className: classNames(css.inputDecorator, css["icon-".concat(direction)])
      }, icon)));
    };
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.state = {
      cursorPosition: 0
    };
    return _this;
  }
  _inherits(NewTextField, _Component);
  return _createClass(NewTextField, [{
    key: "render",
    value: function render() {
      var showErrorIcon = this.props.category === inputVarientType.SECONDARY;
      return /*#__PURE__*/React.createElement(LabelAndHint, {
        id: this.props.id,
        className: this.props.className,
        icon: this.props.icon,
        iconViewBox: this.props.iconViewBox,
        iconClick: this.props.iconClick,
        iconClickClassName: this.props.iconClickClassName,
        onIconClick: this.props.onIconClick,
        label: this.props.label,
        value: this.props.value,
        pristine: this.props.pristine,
        maxLength: this.props.maxLength,
        hintText: this.props.hintText,
        errorText: this.props.errorText,
        disabled: this.props.disabled,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        render: this.renderInput,
        saveSpaceForIcons: this.props.saveSpaceForIcons,
        highlightOnBlur: this.props.highlightOnBlur,
        direction: this.props.direction,
        dataAutId: this.props.dataAutId,
        highlightInput: this.props.highlightInput,
        containerClassName: this.props.containerClassName,
        category: this.props.category,
        showErrorIcon: showErrorIcon,
        roundedInputPixel: this.props.roundedInputPixel,
        hideMaxLength: this.props.hideMaxLength,
        hintTextClass: this.props.hintTextClass
      });
    }
  }]);
}(Component);
NewTextField.defaultProps = {
  autoFocus: false,
  className: '',
  direction: null,
  disabled: false,
  errorText: '',
  extras: {},
  highlightOnBlur: false,
  hintText: '',
  icon: null,
  iconClick: null,
  iconClickClassName: '',
  id: '',
  dataAutId: '',
  label: '',
  maxLength: null,
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onIconClick: function onIconClick() {},
  prefix: '',
  pristine: true,
  saveSpaceForIcons: false,
  style: {},
  type: 'text',
  value: '',
  containerClassName: '',
  prefixClassName: '',
  category: inputVarientType.PRIMARY,
  retainCursorPosition: false,
  roundedInputPixel: false,
  hideMaxLength: false,
  hintTextClass: '',
  focusInput: false
};
export default NewTextField;